import { useCurrent } from '@/hooks/useCurrent';

export const useGetAbsoluteUrl = (getApiUrl: boolean = false) => {
  const current = useCurrent();

  const absoluteUrl =
    getApiUrl === true
      ? process.env.NEXT_PUBLIC_API_URL
      : current.tenant?.absoluteUrl;

  const getAbsoluteUrl = absoluteUrl
    ? (path?: string): string => {
        const cleanedPath = path
          ? path.startsWith('/')
            ? path
            : `/${path}`
          : '/';
        return `${absoluteUrl}${cleanedPath}`;
      }
    : null;

  return {
    getAbsoluteUrl,
    loading: current.loading,
  };
};
